<template>
  <div class="col-4 mt-2" :class="tagClass" v-if="propertie.id != 18">
    <app-input-text
      v-if="propertie.propertie_type_id == 1 || propertie.propertie_type_id == 2
      || propertie.propertie_type_id == 5 || propertie.propertie_type_id == 15 || propertie.propertie_type_id == 16"
      :contentType="propertie.propertie_type_id"
      :label="propertie.name"
      :icon="true"
      :id="`${id}-${propertie.propertie_type_id}-${task}`"
      :value="value"
      :userAdmin="userAdmin"
      @input="inputValue"
      @change="inputValueChange"
    />
    <app-input-search-add-3
      v-if="propertie.propertie_type_id == 14"
      :items="menbers"
      :disabled="false"
      :defaultValue="JSON.parse(JSON.stringify(value))"
      :label="propertie.name"
      :addNewValue="userAdmin"
      :id="`${id}-${propertie.propertie_type_id}-${task}`"
      :userAdmin="userAdmin"
      @input="inputValue"
      @updatePropertiesInSelected="updatePropertiesInSelected"
      c_css
    />
    <app-input-search-add-2
     v-if="propertie.propertie_type_id == 6"
      :items="JSON.parse(propertie.values)"
      :disabled="false"
      :defaultValue="parseInt(value)"
      :label="propertie.name"
      :addNewValue="userAdmin"
      :id="`${id}-${propertie.propertie_type_id}-${task}`"
      :userAdmin="userAdmin"
      @input="inputValue"
      @updatePropertiesInSelected="updatePropertiesInSelected"
      c_css
    />
    <app-input-date
      v-if="propertie.propertie_type_id == 13"
      :label="propertie.name"
      c_css
      @input="inputValue"
      @change="inputValueChange"
      :id="`${id}-${propertie.propertie_type_id}-${task}`"
      :value="value"
      :userAdmin="userAdmin"
    />
  </div>
</template>
<script>

//import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppInputText from "@/components/AppInputText/AppInputTextFormats.vue";
import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
import AppInputSearchAdd2 from "@/components/AppInputSearchAdd/AppInputSearchAdd2.vue";
import AppInputSearchAdd3 from "@/components/AppInputSearchAdd/AppInputSearchAdd3.vue";

export default {
  props: {
    value:{
      type: [String, Number, Array, Object]
    },
    id:{
      type: [String, Number]
    },
    task:{
      type: [String, Number]
    },
    def: {
      type: [String, Object]
    },
    propertie: {
      type: [Array, Object]
    },
    userAdmin:{
      type: Number,
      default: 0
    }, 
    menbers:{
      type: [Array, Object]
    }
  },
  components: {
    //AppInputSelect,
    AppInputText,
    AppInputDate,
    AppInputSearchAdd2,
    AppInputSearchAdd3
  },
  data(){
    return {
      tagClass : this.propertie.propertie_type_id == 6 ? 'col-search-box' : ''
    }
    
  },
  methods: {
    checkFormFilled() {},
    inputValue(value, id){
      this.$emit("updateCustomPropertie", value, id)
    },
    inputValueChange(value, id){
      this.$emit("updateCustomPropertieChange", value, id)
    },
    updatePropertiesInSelected(id, data){
      this.$emit('updatePropertiesInSelected', id, data);
    }
  }
};
</script>